import { validateMany as validatePeople, buildContent as buildPersonContent } from '@/services/legal-ad-form/components/person';

export const validate = partnerList => {
  return validatePeople(partnerList, true);
};

export const buildContent = partnerList => {
  return partnerList.map(partner => buildPersonContent(partner, 'Associés tenus indéfiniment et solidairement des dettes sociales'));
};